interface FeatureFlags {
  isComingSoonEnabled: boolean;
}

export const features: FeatureFlags = {
  // Passer à true pour réafficher la page « bientôt disponible » à la place
  // de la page d'accueil.
  isComingSoonEnabled: false,
}; 